import moment from "moment";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import { useTranslation } from "react-i18next";

function ChatItem({ setDetailView, setChatData, ...chat }: any) {
  const history = useHistory()
  const { path } = useRouteMatch();
  const { user } = AppStateHandler.getState();
  const { t, i18n } = useTranslation();
  const subId = user?.username;
  const dp = subId === chat.senderId ? chat.receiverImage : chat.senderImage;
  const name = subId === chat.senderId ? chat.receiverName : chat.senderName;
  const timestamp = chat.createdAt;

  return (
    <>
      <Link to={path + "/" + chat.chatId} onClick={() => { setChatData(chat); history.push(path) }} >
        <div className={` d-flex justify-content-between position-relative ${i18n.dir()==='rtl'?'pr-5':'pl-5'} cursor-pointer`}>
          <div className={`message_user_icon ${i18n.dir()==='rtl'?'message_user_icon_posRTL':'message_user_icon_posLTR'}`}>
            <img src={dp && dp !== "" ? dp : "/assets/images/profile-camera.png"} className="rounded-circle" width="39" height="40" alt="" />
            {chat.online ? <i className="fa fa-circle base_color fz10" aria-hidden="true"></i> : ""}
          </div>
          <h4 className={` fz14 mb-1 ${i18n.dir()==='rtl'?'pr-3':'pl-3'}`}>{name}</h4>
          <span className="fz12 text-secondary">{timestamp ? moment(new Date(timestamp)).fromNow() : ""}</span>
        </div>
        <p className={` fz12 mb-0  ${i18n.dir()==='rtl'?'text-right messages_padding_RTL Almaraisemibold':'messages_padding_LTR poppinsregular'}`}>{chat.message}</p>
      </Link>
      <hr />
    </>
  )
}
export default ChatItem;
